export default __webpack_public_path__ + "static/media/Shoes6.876af51a.png";